import { IApplicationState } from '../../types/redux';
import { getPromos } from './getPromos';

export function getPromoCount(state: IApplicationState): number {
  return getPromos(state).length;
}
